"use client";

import React, { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, HeartPulse } from "lucide-react";
import { Button } from "@/components/ui/button";
import HomeAppointmentModal from "@/pages/Home/sections/HomeAppointmentModal";
export default function CareCta() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const shouldReduceMotion = useReducedMotion();
  return <section id="carecalltoaction" data-nav="dark" className="relative overflow-hidden border-b-2 border-primary bg-gradient-to-b from-[#152238] to-[#2a1520] py-16 text-secondary-foreground sm:py-20">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-0 flex items-center justify-center opacity-30">
        <div className="size-96 rounded-full bg-primary/20 blur-3xl" />
        <div className="size-[500px] rounded-full bg-chart-3/15 blur-3xl" />
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="mx-auto max-w-3xl text-center">
          {}
          <div aria-hidden="true" className="absolute -top-10 left-1/2 -translate-x-1/2 size-64 bg-primary/20 blur-3xl pointer-events-none" />
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border/30 bg-secondary/80 px-3.5 py-1.5 font-mono text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-primary">
            <HeartPulse className="size-4" />
            <span>Dedicated Cardiovascular Excellence</span>
          </div>

          {}
          <h2 className="font-serif text-3xl font-semibold tracking-[-0.02em] text-secondary-foreground sm:text-4xl md:text-5xl">
            Your Heart Deserves Exceptional Care
          </h2>

          {}
          <p className="mt-5 text-base leading-relaxed text-muted-foreground sm:text-lg md:text-xl">
            Experience world-class cardiovascular care with our dedicated team of specialists. We are committed to your long-term heart health.
          </p>

          {}
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" onClick={() => setIsModalOpen(true)} className="group h-12 rounded-lg bg-primary px-8 text-base font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-[background-color,box-shadow] duration-300 hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/35">
              Schedule Appointment
              <ArrowRight className="size-4 transition-[transform] duration-200 group-hover:translate-x-1" />
            </Button>
          </div>
        </motion.div>
      </div>

      <HomeAppointmentModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>;
}
